import type { RuleSet } from './types.js';

export const RUSSIAN_SHASHKI: RuleSet = {
  id: 'russian',
  boardSize: 8,
  startingRows: 3,
  piecesOnDarkSquares: true,
  manCapturesBackward: true,
  flyingKings: true,
  maxCaptureRequired: false,
  promoteMidJump: true,
  drawAfterQuietMoves: 15,
  firstPlayer: 'white',
};
